/* eslint-disable no-magic-numbers */
import { Color } from '@technology/web3d';
import { rgbCssHexToNumber } from '@trimble/utilities';

export const cssToWeb3dColor = (color: string): Color => {
  const colorNumber = rgbCssHexToNumber(color);
  if (colorNumber === 0) return new Color(0, 0, 0);

  const red = (colorNumber >> 16) & 0xff;
  const green = (colorNumber >> 8) & 0xff;
  const blue = colorNumber & 0xff;

  return new Color(red / 0xff, green / 0xff, blue / 0xff);
};
